import axios from 'axios';
import {getLocalStorageSync, LocalStorageType} from '../configs/localStorage';
import {onLogout} from '../configs/util';

export const UseNetworkGet = async (url: string, headerOptions?: any) => {
  let data = null;
  let error = null;

  try {
    const response = await axios.get(`${url}`, {
      headers: headerOptions
        ? headerOptions
        : {
            'Content-Type': 'application/json',
            'X-AppPlatform': 'VOLT_WEB_APP',
            Authorization: `Bearer ${getLocalStorageSync(
              LocalStorageType.ACCESS_TOKEN,
            )}`,
          },
    });
    data = response.data;
    error = null;
  } catch (err) {
    error = await handleError(err);
    data = null;
  }
  return {data, error};
};

export const UseNetworkPost = async (
  url: string,
  body?: any,
  headerOptions?: any,
) => {
  let data = null;
  let error = null;

  try {
    const response = await axios.post(`${url}`, body, {
      headers: headerOptions
        ? headerOptions
        : {
            'Content-Type': 'application/json',
            'X-AppPlatform': 'VOLT_WEB_APP',
            Authorization: `Bearer ${getLocalStorageSync(
              LocalStorageType.ACCESS_TOKEN,
            )}`,
          },
    });
    data = response.data;
    error = null;
  } catch (err) {
    error = await handleError(err);
    data = null;
  }
  return {data, error};
};

export const UseNetworkPatch = async (
  url: string,
  body?: any,
  headerOptions?: any,
) => {
  let data = null;
  let error = null;

  try {
    const response = await axios.patch(`${url}`, body, {
      headers: headerOptions
        ? headerOptions
        : {
            'Content-Type': 'application/json',
            'X-AppPlatform': 'VOLT_WEB_APP',
            Authorization: `Bearer ${getLocalStorageSync(
              LocalStorageType.ACCESS_TOKEN,
            )}`,
          },
    });
    data = response.data;
    error = null;
  } catch (err) {
    error = await handleError(err);
    data = null;
  }
  return {data, error};
};

const handleError = async (error: any) => {
  //Logout user on forbidden or authentication failure response
  if (
    error &&
    (error.response.status === 403 || error.response.status === 401)
  ) {
    await onLogout();
  }
  return error;
};
